module.exports = __webpack_public_path__ + "static/media/Fairytale.3af87728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/Fairytale.png
// module id = 1334
// module chunks = 3